import { Outlet, useNavigate, useLocation } from 'react-router';
import { Suspense, useEffect } from 'react';
import { PageProgress } from '@/shared/components/feedback/page-progress';
import { RouteErrorBoundary } from '@/shared/components/feedback/route-error-boundary';
import { useAuthenticate } from '@/shared/hooks/use-authenticate';
import { useVendorSocket } from '@/shared/hooks/use-vendor-socket';
import { ConnectionBanner } from '@/features/room/components/connection-banner';

export function RootLayout() {
  const { data: auth } = useAuthenticate();
  useVendorSocket(!!auth);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      auth?.assessmentStatus === 'submitted' &&
      location.pathname !== '/submitted' &&
      location.pathname !== '/expired'
    ) {
      void navigate('/submitted', { replace: true });
    }
  }, [auth?.assessmentStatus, location.pathname, navigate]);

  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      <ConnectionBanner />
      <RouteErrorBoundary key={location.pathname}>
        <Suspense fallback={<PageProgress />}>
          <main id="main-content" tabIndex={-1}>
            <Outlet />
          </main>
        </Suspense>
      </RouteErrorBoundary>
    </>
  );
}
